import { useRouter } from 'next/router'
import { ReactElement, useContext, useEffect, useState } from 'react'
import { ModalKeyboardShortcuts } from '../../modules/modals/modal-keyboard-shortcuts'
import { AuthenticatedContainerType } from './types'
import { DownloadQueueContainer } from '../download-queue-container'
import { ContextShell } from '../../modules/context'
import { Loading } from '../../components/loading'
import styles from './styles.module.scss'
import { Sidebar } from '../../modules/sidebar/sidebar'
import { ModalGetApp } from '../../modules/modals/modal-get-app'
import { useUserLogged } from '../../hooks/auth/use-user-logged'
import { readShellDisabled } from '../../hooks/iframe/is-shell-disabled'
import { ModalReferralLink } from '../../modules/modals/modal-referral-link'
import { ModalGroupPlanTrial } from '../../modules/modals/modal-group-plan-promotion'
import { ModalExternalPaywall } from '../../modules/modals/modal-external-paywall'

export const routesToNotShowAppFrame = [
  '/',
  '/login',
  '/logout',
  '/reset-password'
]

const getRoutes = (isUserLoogedIn: boolean): string[] => {
  return routesToNotShowAppFrame.filter(() => {
    if (!isUserLoogedIn) return true

    return true
  })
}

export const AuthenticatedContainer = ({
  children
}: AuthenticatedContainerType): ReactElement => {
  const { pathname } = useRouter()
  const { user, posthogFlagsLoaded } = useContext(ContextShell)
  const { isUserLoogedIn } = useUserLogged()
  const [sidebarDisabled, setSidebarDisabled] = useState(false)

  useEffect(() => {
    setSidebarDisabled(readShellDisabled())
  }, [])

  const routes = getRoutes(isUserLoogedIn)
  if (routes.includes(pathname)) {
    return children
  }

  return (
    <div className={styles.container}>
      {!sidebarDisabled && (
        <div className={styles.sidebar}>
          <Sidebar loading={!user} />
        </div>
      )}
      <div className={styles.content}>
        {!user && !posthogFlagsLoaded ? (
          <Loading className={styles.loading} />
        ) : (
          <>
            <ModalGetApp />
            <ModalReferralLink />
            <ModalKeyboardShortcuts />
            <ModalGroupPlanTrial />
            <ModalExternalPaywall />
            <DownloadQueueContainer />
            {children}
          </>
        )}
      </div>
    </div>
  )
}
